module.exports = __webpack_public_path__ + "img/I-3.e66150e2.svg";